<template>
    <div>
        <div v-if="user">
            <b-row>
                <b-col>
                    <o-card :title="$t('core.welcome')">
                        <strong>
                            {{ $t('core.welcome') }} {{ user.name }}
                        </strong>

                        <div class="mt-3">
                            <router-link v-if="hasPermission([
                                'GET api/verifications/contracts',
                                'POST api/verifications/deny',
                                'POST api/verifications/allow',
                                'POST api/verifications/delete-picture',
                                'POST api/verifications/upload-picture',
                                'GET api/verifications/contracts/{id}'
                                ])" :to="{ name: 'verifications.verifications'}" class="btn btn-primary mb-2 mr-1" tag="div">
                                <fa icon="check-double" size="lg"/>
                                <br>
                                {{ $t('sandoz.verifications_old') }}
                            </router-link>

                            <router-link v-if="hasPermission([
                                'GET api/verifications-new/contracts',
                                'POST api/verifications/deny',
                                'POST api/verifications/allow',
                                'POST api/verifications/delete-picture',
                                'POST api/verifications/upload-picture',
                                'GET api/verifications-new/contracts/{id}'
                                ])" :to="{ name: 'verifications.new_verifications'}" class="btn btn-primary mb-2 mr-1" tag="div">
                                <fa icon="check-double" size="lg"/>
                                <br>
                                {{ $t('sandoz.verifications') }}
                            </router-link>

                            <router-link v-if="hasPermission(['GET api/contracts'])" :to="{ name: 'contracts.list'}"
                                         class="btn btn-primary mb-2 mr-1" tag="div">
                                <fa icon="file-contract" size="lg"/>
                                <br>
                                {{ $t('sandoz.contracts') }}
                            </router-link>

                            <router-link v-if="hasPermission(['GET api/customers'])" :to="{ name: 'customers.list'}"
                                         class="btn btn-primary mb-2 mr-1" tag="div">
                                <fa icon="users" size="lg"/>
                                <br>
                                {{ $t('sandoz.cp_customers') }}
                            </router-link>

                            <router-link v-if="hasPermission(['GET api/customer-logins'])" :to="{ name: 'customer_logins.list'}"
                                         class="btn btn-primary mb-2 mr-1" tag="div">
                                <fa icon="users" size="lg"/>
                                <br>
                                {{ $t('sandoz.cp_logins') }}
                            </router-link>
                        </div>
                    </o-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({
            user: 'auth/user'
        })
    },
    methods: {
        hasPermission(item) {
            let result = true
            let permissions = item
            let user = this.user
            if (!user.is_super_user && permissions) {
                permissions.forEach((permission) => {
                    if (!user.routePermissions.includes(permission)) {
                        result = false
                    }
                })
            }
            return result
        }
    }
}
</script>
